import React, { useEffect, useState } from "react";
import { Button, FormGroup, Input } from "reactstrap";

import {
  convertToPersianNumber,
  isIranPhoneNumber,
  toEnglishDigits,
} from "../../modules/helper";

function SignInWithMobile({ sendOTP, phone }) {
  const [state, setState] = useState({
    isValid: false,
    phone: phone,
  });

  const onSubmit = () => {
    if (state.isValid) {
      sendOTP(toEnglishDigits(state.phone), "phone");
    }
  };

  function regexHandler(e) {
    const { value } = e.target;
    setState((prev) => ({ ...prev, phone: value }));

    if (isIranPhoneNumber(toEnglishDigits(value))) {
      setState((prev) => ({
        ...prev,
        isValid: true,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        isValid: false,
      }));
    }
  }

  useEffect(() => {
    phone
      ? setState((prev) => ({
          ...prev,
          isValid: true,
        }))
      : setState((prev) => ({
          ...prev,
          isValid: false,
        }));
  }, []);

  function signInWithPressingEnterKey(e) {
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      onSubmit();
    }
  }

  return (
    <>
      <div className="mobile-login-input">
        <FormGroup>
          <div className="iranCode">۹۸+</div>
          <Input
            type="tel"
            name="telephone"
            placeholder="-----------"
            value={convertToPersianNumber(state.phone)}
            onChange={regexHandler}
            onKeyDown={signInWithPressingEnterKey}
          />
        </FormGroup>
      </div>
      <div
        className={`verification-button ${
          state.isValid ? "activatedParentShadow" : "disabledParentShadow"
        } `}
      >
        <Button
          className={`${state.isValid ? "activatedButton" : "disabledButton"}`}
          disabled={state.isValid === true ? false : true}
          active
          block
          color="primary"
          size=""
          onClick={onSubmit}
        >
          ارسال کد تایید
        </Button>
      </div>
    </>
  );
}

export default SignInWithMobile;
